var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login bgLogin",
    staticStyle: {
      height: "100%"
    }
  }, [_c("div", {
    staticClass: "page-login--layer"
  }, [_vm._m(0), _c("div", {
    staticClass: "right-login"
  }, [_c("div", {
    staticClass: "page-login--content",
    attrs: {
      flex: "dir:top main:justify cross:stretch box:justify"
    }
  }, [_c("div", {
    staticClass: "page-login--content-main",
    attrs: {
      flex: "dir:top main:center cross:center"
    }
  }, [_c("div", {
    staticStyle: {
      width: "580px",
      margin: "0 auto"
    }
  }, [_c("div", {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _c("div", {
    staticClass: "page-login--form",
    on: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_c("el-form", {
    ref: "loginForm",
    staticStyle: {
      width: "460px"
    },
    attrs: {
      "label-position": "top",
      rules: _vm.rules,
      model: _vm.formLogin,
      size: "default"
    }
  }, [_c("el-form-item", {
    staticClass: "dis",
    attrs: {
      prop: "username"
    }
  }, [_c("el-input", {
    staticClass: "login-input-text",
    attrs: {
      type: "text",
      placeholder: "用户名",
      autocomplete: "on",
      name: "username"
    },
    model: {
      value: _vm.formLogin.username,
      callback: function callback($$v) {
        _vm.$set(_vm.formLogin, "username", $$v);
      },
      expression: "formLogin.username"
    }
  }), _c("img", {
    staticClass: "login_img",
    attrs: {
      src: require("@/assets/image/admin/login_user.png")
    }
  })], 1), _c("el-form-item", {
    staticClass: "dis",
    attrs: {
      prop: "password"
    }
  }, [_c("el-input", {
    staticClass: "login-input-text",
    attrs: {
      type: "password",
      placeholder: "密码"
    },
    model: {
      value: _vm.formLogin.password,
      callback: function callback($$v) {
        _vm.$set(_vm.formLogin, "password", $$v);
      },
      expression: "formLogin.password"
    }
  }), _c("img", {
    staticClass: "login_img",
    attrs: {
      src: require("@/assets/image/admin/login_pass.png")
    }
  })], 1), _c("el-form-item", {
    staticClass: "clearfix dis",
    attrs: {
      prop: "code"
    }
  }, [_c("el-input", {
    staticClass: "login-input-text code_input",
    staticStyle: {
      width: "280px",
      float: "left",
      "margin-right": "455px"
    },
    attrs: {
      maxlength: "4",
      type: "text",
      placeholder: "验证码"
    },
    model: {
      value: _vm.formLogin.code,
      callback: function callback($$v) {
        _vm.$set(_vm.formLogin, "code", $$v);
      },
      expression: "formLogin.code"
    }
  }), _c("img", {
    staticClass: "login_img",
    attrs: {
      src: require("@/assets/image/admin/login_code.png")
    }
  }), _c("div", {
    staticClass: "vcode",
    on: {
      click: _vm.changeCode
    }
  }, [_c("v-code", {
    attrs: {
      identifyCode: _vm.identifyCode
    }
  })], 1)], 1), _c("div", {
    staticClass: "sub",
    on: {
      click: _vm.submit
    }
  }, [_vm._v("登录")]), _c("div", [_c("a", {
    staticClass: "software_download",
    attrs: {
      target: "_blank",
      href: "/static/software/software.zip"
    }
  }, [_vm._v("驱动下载")])])], 1)], 1)])])])]), _vm._m(1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "left-login"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/image/admin/home_index_left.png")
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login--content-footer"
  }, [_c("p", {
    staticClass: "page-login--content-footer-copyright",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" v2025.10.30.1 ")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };